import { SUPPORTED_LOCALES } from "../localization/constants";

export const ROOT_ROUTE = `/:locale(${SUPPORTED_LOCALES.join("|")})`;
